<template>
  <div class="flex flex-col">
    <input type="email" :placeholder="$t('signin.email').toUpperCase()" v-model="form.email" :aria-label="$t('signin.email')"
      class=" p-1 text-sm">
    <input type="password" :placeholder="$t('signin.password').toUpperCase()" v-model="form.password" :aria-label="$t('signin.password')"
      class=" p-1 text-sm">
    <button class="w-full bg-b2c-red-300 text-white text-sm py-1 my-3 cursor-pointer" @click="login">
      {{ $t('login.enter') }}
    </button>
    <div class="w-full text-center">
      <button class="no-underline text-gray-600 text-xs pb-2" :class="fontHairline()"
        @click="resetPassword()">
          {{ $t('login.pw-forgot') }}
      </button>
    </div>
    <section class="w-full text-center" :aria-label="$t('login.register')">
      <span class="text-gray-600 text-xs" :class="fontHairline()">
        {{ $t('login.new') }}
      </span>
      <router-link
        @click.native="closeDropdown"
        to="/signin"
        class="no-underline font-bold text-blackish text-xs">
          {{ $t('login.register') }}
      </router-link>
    </section>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  data() {
    return {
      form: {
        email: '',
        password: '',
      },
    };
  },

  methods: {
    ...mapActions({
      signIn: 'auth/signIn',
      changeLocale: 'auth/changeLocale',
    }),
    async login() {
      await this.signIn(this.form)
        .then(() => {
          this.showDropdown = false;
          this.createNotification('success', `${this.$t('notifications.successfulLogin')}`);
          if (this.$router.currentRoute.path === '/signin') {
            this.$router.push(this.$route.query.redirect || '/profile');
          }
        }).catch(() => {
          this.createNotification('error', `${this.$t('notifications.credentialsInvalid')}`);
        });
    },

    closeDropdown() {
      this.$emit('close');
    },

    resetPassword() {
      window.location = '/password/reset';
    },
  },
};
</script>

<style lang="scss" scoped>

input {
  @apply border border-gray-500 px-2 mb-3;
}

</style>
